import { Cpu } from "lucide-react";

export interface WorkspaceSidebarAiMetaProps {
  models?: {
    walker?: string | null;
    walker_reported?: string | null;
    judge?: string | null;
    judge_reported?: string | null;
    velocity_sec_per_step?: number | null;
  } | null;
  judgeMeta?: {
    provenance?: {
      model?: string | null;
    } | null;
  } | null;
}

export function WorkspaceSidebarAiMeta({
  models,
  judgeMeta,
}: WorkspaceSidebarAiMetaProps) {
  if (!models && !judgeMeta) return null;

  const judgeModel = models?.judge ?? judgeMeta?.provenance?.model;

  return (
    <div className="border-t border-border/60 pt-3 text-xs space-y-2">
      <div className="flex items-center justify-between">
        <p className="text-muted-foreground flex items-center gap-1.5 font-medium">
          <Cpu className="size-3.5 text-muted-foreground" />
          <span>AI Execution</span>
        </p>
        {models?.velocity_sec_per_step != null && (
          <span className="font-mono text-xs text-muted-foreground bg-muted/60 px-1.5 py-0.5 rounded">
            ~{models.velocity_sec_per_step.toFixed(1)}s/step
          </span>
        )}
      </div>
      <div className="space-y-1.5 text-xs">
        {(models?.walker || models?.walker_reported) && (
          <div className="flex items-center justify-between rounded bg-muted/40 px-2 py-1">
            <span className="text-muted-foreground">Walker</span>
            <div className="flex items-center gap-1.5">
              {models.walker && (
                <span className="font-medium text-foreground">
                  {models.walker}
                </span>
              )}
              {models.walker_reported &&
                models.walker_reported !== models.walker && (
                  <span className="font-mono text-xs text-muted-foreground">
                    ({models.walker_reported})
                  </span>
                )}
            </div>
          </div>
        )}
        {(judgeModel || models?.judge_reported) && (
          <div className="flex items-center justify-between rounded bg-muted/40 px-2 py-1">
            <span className="text-muted-foreground">Judge</span>
            <div className="flex items-center gap-1.5">
              {judgeModel && (
                <span className="font-medium text-foreground">
                  {judgeModel}
                </span>
              )}
              {models?.judge_reported &&
                models.judge_reported !== judgeModel && (
                  <span className="font-mono text-xs text-muted-foreground">
                    ({models.judge_reported})
                  </span>
                )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
